import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { StaircaseListService } from '../../service/data/staircase-list.service';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-staircase-list',
    templateUrl: './staircase-list.component.html',
    styleUrls: ['./staircase-list.component.scss'],
    providers: [StaircaseListService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StaircaseListComponent implements OnInit, OnDestroy {
  constructor(
    private _service: StaircaseListService,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  floors: { floorIndex: number; apartments: any[] }[] = [];
  private _subscription = new Subscription();
  ngOnInit() {
    this._subscription.add(
      this._activatedRoute.paramMap
        .pipe(
          switchMap(map => {
            let id = map.get('id');
            if (id) {
              return this._service.getStaircaseList(id);
            }
          })
        )
        .subscribe(result => {
          let floor = undefined;
          for (let row of result) {
            if (floor === undefined || floor.floorIndex !== row.floorIndex) {
              floor = { floorIndex: row.floorIndex, apartments: [] };
              this.floors.push(floor);
            }
            floor.apartments.push(row);
          }
        })
    );

    setInterval(
      () => {
        if (new Date().getHours() === 3) window.location.reload();
      },
      1000 * 60 * 30
    );
  }
}
